import React from 'react';
import c from 'classnames';
import styles from './Filter.css';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { changeRelatedListTypePersistent } from '../../ducks';
import { documentSetCookie } from '../../cookie';
import { ClickElement } from '../form';
import { isDateToppers, ListType } from '../../apis/dumpert';
import { adBreakPoint } from '../../lib/helpers';
import { FILTER } from '../../lib/labels';
import { useCurrentBreakPoint, useShowingOnScroll } from '../commons';
import * as ReactGA from 'react-ga';

export const Filter = ({
  typeOfList,
  relatedItemId,
  tagId,
  isItemViewPage,
  noItemLoaded,
  isModal,
}) => {
  const showing = useShowingOnScroll();
  const currentBreakPoint = useCurrentBreakPoint();
  const isToppers = [
    ListType.toppers,
    ListType.top_dag,
    ListType.top_week,
    ListType.top_maand,
  ].includes(typeOfList);
  const isLatest = typeOfList === 'latest';
  const isDumpertTv = typeOfList === 'tag' && tagId === 'dumperttv';

  const makeListButton = (type, text, active) => {
    const isActive = typeOfList === type || active;

    const dispatch = useDispatch();

    const props = () => {
      if (relatedItemId && !isModal) {
        return ({ to: { pathname: `/item/${relatedItemId}/${type}` } });
      }
      if (type === 'dumperttv') {
        return ({ to: { pathname: '/tag/dumperttv' } });
      }
      if (isDateToppers(type)) {
        const splitType = type.split('_');
        return ({ to: { pathname: `/${splitType[0]}/${splitType[1]}/` } });
      }
      if (!isItemViewPage) {
        return ({ to: { pathname: `/${type}` } });
      }
    };

    return (
      <ClickElement
        tertiary
        active={isActive}
        ElementType={isItemViewPage && isModal ? 'div' : Link}
        text={text}
        {...props()}
        onClick={() => {
          isItemViewPage
            ? dispatch(changeRelatedListTypePersistent(type))
            : documentSetCookie('list', type);
          ReactGA.event({
            category: 'FilterClick',
            action: type,
            label: isItemViewPage ? 'itemPage' : 'itemsListPage',
          });
        }}
      />
    );
  };

  return (
    <div className={c(
      styles.filter,
      { [styles.filter_detail]: isItemViewPage },
      { [styles.bottom]: !isItemViewPage },
      { [styles.hide]: !showing && !isItemViewPage },
      'container',
    )}>
      {(isItemViewPage) && (
        <>
          { /* Filter for itemViewPage */ }
          {makeListButton(ListType.latest, 'Nieuw')}
          {makeListButton(ListType.toppers, 'Toppers')}
          {!noItemLoaded && (makeListButton(ListType.related, 'Related'))}
        </>
      )}
      {((isLatest || isDumpertTv) && !isItemViewPage && ['XS'].includes(adBreakPoint(currentBreakPoint)) ) && (
        <>
          { /* Filter for Latest / DumpertTV itemsListView */}
          {makeListButton(ListType.latest, 'Nieuw')}
          {makeListButton(ListType.toppers, 'Toppers')}
          {makeListButton(ListType.dumperttv, (
            <>{FILTER.BRAND}<span style={{ 'color': '#6c2', 'display': 'inline-block' }}>TV</span></>
          ), isDumpertTv, true)}
        </>
      )}

      {(isToppers && !isItemViewPage) && (
        <>
          { /* Filter for Toppers / Dag- / Week- / Monthtoppers itemsListView */}
          {['XS'].includes(adBreakPoint(currentBreakPoint)) && (
            <>
              {/* Show Latest button only on mobile */ }
              { makeListButton(ListType.latest, 'Nieuw') }
            </>
          )}
          {makeListButton(ListType.toppers, 'Nu')}
          {makeListButton(ListType.top_dag, FILTER.TOP_DAY)}
          {makeListButton(ListType.top_week, FILTER.TOP_WEEK)}
          {makeListButton(ListType.top_maand, FILTER.TOP_MONTH)}
        </>
      )}
    </div>
  );
};
